import DOMPurify from 'dompurify';

import { MessageCard, StyledRichText } from './styles';

const CheckoutInstructionsCard = ({
  message = '',
  className,
}: {
  message?: string | Node;
  className?: string;
}): React.ReactElement => (
  <MessageCard className={className}>
    <StyledRichText dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }} />
  </MessageCard>
);
export default CheckoutInstructionsCard;
